/**
 * Blurhash generation utility — wraps expo-image native encoder.
 *
 * Returns null on web (no native encoder) and on failure (non-blocking).
 * [4, 3] components = standard quality/size balance (~20-30 char string).
 */
import { Platform } from 'react-native'
import { Image, type ImageSource } from 'expo-image'

export async function generateBlurhash(uri: string): Promise<string | null> {
  if (Platform.OS === 'web') return null
  try {
    return await Image.generateBlurhashAsync(uri, [4, 3])
  } catch {
    return null
  }
}

/**
 * Wrap a blurhash string into the object shape `expo-image` expects for its
 * `placeholder` prop. Passing the raw string directly is a bug: expo-image
 * treats strings as URIs and the browser then tries to GET
 * `/<current-route>/<blurhash>` (percent-encoded) → ERR_HTTP2_PROTOCOL_ERROR.
 * Always route blurhash values through this helper.
 */
export function toPlaceholder(blurhash: string | null | undefined): ImageSource | undefined {
  return blurhash ? { blurhash } : undefined
}

/**
 * Neutral soft-gradient placeholder for remote images that have no stored
 * blurhash (chat media, dispute evidence, org logos). Prefer a real
 * per-image hash whenever the schema carries one.
 */
export const GENERIC_IMAGE_BLURHASH = 'L6PZfSi_.AyE_3t7t7R**0o#DgR4'
